import { useContext } from "react";
// import { AuthContext } from "../context/AuthProvider";
import { AuthContext } from "../context/AuthContext";

/**
 * Custom hook for accessing authentication context
 * @throws {Error} If used outside of AuthProvider
 * @returns {Object} Authentication context provider with the following values:
 * @param {Object} user - Current authenticated user object or null
 * @param {boolean} isAuthenticated - Boolean indicating if user is authenticated
 * @param {boolean} loading - Boolean indicating loading state
 * @param {Function} login - Function to authenticate user
 * @param {Function} register - Function to register new user
 * @param {Function} sendVerificationCode - Function to send verification code
 * @param {Function} verifyAccount - Function to verify user account
 * @param {Function} restorePassword - Function to initiate password reset
 * @param {Function} confirmRestorePassword - Function to confirm password reset
 * @param {Function} logout - Function to log out user
 */
export default function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }

  return context;
}
